import { render, staticRenderFns } from "./LoadingPlaceholder.vue?vue&type=template&id=72d7245e&scoped=true&"
import script from "./LoadingPlaceholder.vue?vue&type=script&lang=js&"
export * from "./LoadingPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./LoadingPlaceholder.vue?vue&type=style&index=0&id=72d7245e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d7245e",
  null
  
)

/* custom blocks */
import block0 from "./LoadingPlaceholder.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports